import { useState,useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, billingServiceValidation } from "./billing-order-schema";
import BillingServiceInfo from "./components/BillingOrderInfo";
import { useLocation } from "react-router-dom";
import { getBillingServiceListById,editBillingService,getCustCategorySetting,useCustCriteriaOptionsQuery,downloadAttachment} from "services/data.billing.service";

function EditBillingService() {
  const location = useLocation();
  //const { materialName } = location.state;
  const billServiceId = location.state?.billServiceId;
  const customerCode = location.state?.customerCode;
   console.log("billServiceId in edit page:", billServiceId);
  console.log("customerCode in edit page:", customerCode);
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null)
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const attachmentFileName = formValues?.attachmentFileName;

  useQuery({
    queryKey: ["get-billing-service-list-by-id", { customerCode,billServiceId}],
    queryFn: () => getBillingServiceListById({ customerCode,billServiceId }),
    onSuccess: (data) => {
  const record = data.data.data?.[0];
  console.log("Record for reset:", record);
  setFormValues(record);
},
    //onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editBillingServiceMutation = useMutation(editBillingService, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    //values:formValues,
    resolver: yupResolver(billingServiceValidation),
  });

  

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
    watch
  } = form;

  const selectedCategory = watch("category");

  useEffect(() => {
  if (formValues) {
    console.log("Resetting form with:", formValues);
    reset(formValues);
  }
}, [formValues, reset]);

  const { data: categoryData } = useQuery({
    queryKey: ["cust-category-options", customerCode],
    queryFn: () => getCustCategorySetting({ customerCode }),
    enabled: !!customerCode,
  });

  const { data: criteriaData } = useQuery({
    queryKey: ["cust-criteria-options", customerCode, formValues?.category,selectedCategory],
    queryFn: () =>
      useCustCriteriaOptionsQuery({
        customerCode,
        category: selectedCategory,
      }),
    enabled: !!customerCode && !!formValues?.category,
  });
  const downloadAttachmentMutation = useMutation(downloadAttachment);
  const handleDownload = (fileName) => {
  if (!fileName) {
    alert("No attachment found");
    return;
  }

  downloadAttachmentMutation.mutate(fileName, {
    onSuccess: (res) => {
      // 🔥 convert blob to downloadable file
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName); // file name
      document.body.appendChild(link);
      link.click();

      link.remove();
    },
    onError: (err) => {
      console.error("Download failed:", err);
    },
  });
};

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
    // categoryOptions: categoryData?.data ?? [],
    // criteriaOptions: criteriaData?.data ?? [],
    categoryOptions: categoryData?.data?.data ?? [],
    criteriaOptions: criteriaData?.data?.data ?? [],
  };
  const onSubmit = (data) => {
    editBillingServiceMutation.mutate(data, {
      onSuccess: () => {
      },
    });
  };
  const editStatus = editBillingServiceMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <BillingServiceInfo {...infoProps} />
  <div style={{ marginTop: "10px" }}>
    <label>Attachment:</label>
    <div>
      <span
        style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
        onClick={() => handleDownload(attachmentFileName)}
        
      >{attachmentFileName}</span>
    </div>
  </div>
        <SaveButton label="Save" disabled={!isDirty && editStatus} url="/billing/billing-service" />
      </form>
    </Layout>
  );
}

export default EditBillingService;
